module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Bold.woff2";